const HowToPlayContent = ({ hideLoneWolf = false }: { hideLoneWolf?: boolean }) => {
  return (
    <div className="space-y-5">
      {/* Rule 1 */}
      <div className="rounded-xl border border-border/50 bg-white p-5 shadow-sm">
        <div className="flex items-start gap-4">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-forest text-white text-sm font-bold">
            1
          </span>
          <div>
            <h2 className="font-display text-lg font-semibold text-forest mb-1">
              Everyone Plays Together
            </h2>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Every player in the game has to be on the course when a birdie is scored. No texting in your birdies from the couch.
            </p>
          </div>
        </div>
      </div>

      {/* Rule 2 */}
      <div className="rounded-xl border border-border/50 bg-white p-5 shadow-sm">
        <div className="flex items-start gap-4">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-forest text-white text-sm font-bold">
            2
          </span>
          <div>
            <h2 className="font-display text-lg font-semibold text-forest mb-1">
              Play It Real
            </h2>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Ball down. Putt everything out. No gimmees. The birdie has to count.
            </p>
          </div>
        </div>
      </div>

      {/* Rule 3 */}
      <div className="rounded-xl border border-border/50 bg-white p-5 shadow-sm">
        <div className="flex items-start gap-4">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-forest text-white text-sm font-bold">
            3
          </span>
          <div>
            <h2 className="font-display text-lg font-semibold text-forest mb-1">
              Unique Holes Win
            </h2>
            <p className="text-sm text-muted-foreground leading-relaxed">
              The player who birdies the most holes out of 18 wins. Each hole can only be claimed once per season. An eagle counts too.
            </p>
          </div>
        </div>
      </div>

      {/* Lone Wolf */}
      {!hideLoneWolf && (
        <div className="rounded-xl border border-gold/30 bg-gold/5 p-5 shadow-sm">
          <h2 className="font-display text-lg font-semibold text-forest mb-1">
            Lone Wolf
          </h2>
          <p className="text-xs font-medium text-gold mb-2">Solo Mode</p>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Birdie all 18 holes on your own. Your birdies from group games count toward your solo progress too.
          </p>
        </div>
      )}
    </div>
  );
};

export default HowToPlayContent;
